import { useEffect } from 'react';
import useAppEvent from 'hooks/useAppEvent';
import { AppEventType } from 'models/Events';

const useRefreshOnHostfullyIntegrationEvent = ({
  refreshFn,
}: {
  refreshFn: () => void;
}) => {
  const { subscribe, unsubscribe } = useAppEvent();

  useEffect(() => {
    const hostfullyIntegrationsRefresh: EventListenerOrEventListenerObject =
      refreshFn;
    subscribe(
      AppEventType.HOSTFULLY_INTEGRATIONS_UPDATED,
      hostfullyIntegrationsRefresh,
    );

    return () => {
      unsubscribe(
        AppEventType.HOSTFULLY_INTEGRATIONS_UPDATED,
        hostfullyIntegrationsRefresh,
      );
    };
  }, []);
};

export default useRefreshOnHostfullyIntegrationEvent;
